import { ActionMenu } from "@telluscompany/design-system";
import { Edit, MoreVerticalIcon, Trash2 } from "lucide-react";

import { useLocalization } from "@i18n";

import type { ListAdminUsersResponseItem } from "../../api/admin-user";

interface AdminUsersActionMenuProps {
  user: ListAdminUsersResponseItem;
  onEdit: (user: ListAdminUsersResponseItem) => void;
  onDelete: (user: ListAdminUsersResponseItem) => void;
}

export const AdminUsersActionMenu = ({
  user,
  onEdit,
  onDelete,
}: AdminUsersActionMenuProps) => {
  const { translate } = useLocalization();

  const actions = [
    {
      actions: [
        {
          label: translate("admin.users.button.edit"),
          onClick: () => onEdit(user),
          icon: <Edit size={16} />,
        },
        {
          label: translate("admin.users.button.delete"),
          onClick: () => onDelete(user),
          icon: <Trash2 size={16} />,
          colorTitle: "red" as const,
        },
      ],
    },
  ];

  return <ActionMenu menu={actions} trigger={<MoreVerticalIcon />} />;
};
